<template>
    <div>
        <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">Add Comment</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-md-12" style="padding:2px;display: flex;">
                            <textarea  v-if="show" type="text" ref="commentTextField"
                                class="bg-transparent border rounded text-light form-control input-fields"
                                style="padding-inline-start: 5px;padding-top: 2px;margin: 0px;height: 181px;" v-model="commentText"
                                placeholder="Enter a comment...">
                            </textarea>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <button class="btn btn-outline-secondary ml-1" title="Close" @click="closeDialog()">Cancel</button>
                        <button class="btn btn-outline-primary ml-1" title="Reject with comment" @click="addComment()">{{buttonName?buttonName:'Reject'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import cancelIcon from "../core/InlineCancelField.vue"
export default {
props:['buttonName'],
  data: () => ({
    dialog: true,
    commentText:"",
    selectedFileInfo:null,
    extension:"",
    show:false,
  }),
  components: {
    'cancel-icon':cancelIcon,
  },
  methods:{
      closeDialog(){
          this.$emit("close")
      },
      addComment(){
          this.$emit("handleAddButtonClick",this.commentText)
      },
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          this.$refs.commentTextField.focus()
        })
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;


.label-tree-style{
  font-size: 12px !important;
  color:$dull-text-color;
  margin-top:4px;
  word-break: break-all;
  white-space: pre-wrap;
  margin-inline-start:12px;
}
.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }

  .modal{
    transition: opacity .3s ease;
  }

  
  .modal-content {
    height: 227px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 20%;
}
.modal-header .close {
    margin: -1rem -13px -1rem auto !important;
}
.modal:before {
  content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:$input-field-and-label-font-size !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    margin: -1rem -13px -1rem auto !important;
}

.primary-btn-style{
    button{
        height: 35px;
        width: 95px;
        font-size:$input-field-and-label-font-size;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 16%;
  font-size: $input-field-and-label-font-size;
  margin-top: 11px;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

   ::v-deep{
    .add-search-filter{
        display: inline-flex;
        border: 1px solid #0779fb !important;
        color: #0779fb !important;
        .add-fileds-icon{
            position: absolute;
            inset-inline-start: 10px;
            z-index: 99;
            top: 13px;
        }
        .multiselect{
            min-width:15%;
            margin: -2px 0px;
            .multiselect__tag{
                display:none;
            }
            .multiselect__select{
                display:none;
            }
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus,
        .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after {
            color: $secondary-text-color !important;
            font-size: 20px !important;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }
    }


</style>